import styled from 'styled-components';

export const ModalContent = styled.div`
  & > h3 {
    font-weight: bold;
    margin-bottom: 2rem;
    font-size: 1rem;
  }

  & > div {
    margin-bottom: 1rem;
  }
`;

export const TextfieldWrapper = styled.div`
  width: 12rem;
`;

export const CheckBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 0.5rem;
`;

export const ConfigTableContainer = styled.div`
  margin: 1.5rem 0;
`;

export const InputWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  & > div {
    width: 4rem;
  }
`;
